import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tempeo_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      const path = window.location.pathname;
      if (path.startsWith("/admin") && path !== "/admin/login") {
        localStorage.removeItem("tempeo_token");
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(err);
  }
);

export const setToken = (t) => {
  if (t) localStorage.setItem("tempeo_token", t);
  else localStorage.removeItem("tempeo_token");
};

export const getToken = () => localStorage.getItem("tempeo_token");
